import React from "react";
import { Check } from "lucide-react";

export const STEPS = ["Commodities", "Grades & volumes", "Your details", "Review"];

export default function Stepper({ current }) {
  return (
    <ol className="flex items-center gap-2 md:gap-4" data-testid="wholesale-stepper">
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={label} className="flex items-center gap-2 md:gap-4">
            <div className="flex items-center gap-3">
              <span
                className={`h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold tabular-nums transition-colors ${
                  done ? "bg-[#b08a5f] text-[#10271a]" : active ? "bg-[#f6f1e7] text-[#10271a]" : "bg-[#f6f1e7]/10 text-[#f6f1e7]/60"
                }`}
              >
                {done ? <Check size={14} /> : i + 1}
              </span>
              <span className={`hidden md:block text-[12px] tracking-[0.14em] uppercase ${active ? "text-[#f6f1e7]" : "text-[#f6f1e7]/55"}`}>{label}</span>
            </div>
            {i < STEPS.length - 1 && <span className={`h-px w-6 md:w-10 ${done ? "bg-[#b08a5f]" : "bg-[#f6f1e7]/15"}`} />}
          </li>
        );
      })}
    </ol>
  );
}
